import { render, staticRenderFns } from "./GpsRule.vue?vue&type=template&id=bd43d5e4&scoped=true"
import script from "./GpsRule.vue?vue&type=script&setup=true&lang=js"
export * from "./GpsRule.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GpsRule.vue?vue&type=style&index=0&id=bd43d5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd43d5e4",
  null
  
)

export default component.exports